import styled from 'styled-components';

const CountrySelectorWrapper = styled.div`
  border-color: #000000;
  border-width: 1px;
  border-radius: 4px;
  width: 100%;
  border-style: solid;
  cursor: pointer;
`;

export default CountrySelectorWrapper;
